import { getChannelSelectOptionsSSA } from 'app/syndicatedSponsoredAds/services/servicesSyndicatedSpondoredAds';
import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import withInputErrorMessage from '../withInputErrorMessage';
import remoteOptionSelectFactory from './remoteOptionSelectFactory';
import withSelectFormik from './withSelectFormik';

export default withSelectFormik(withInputErrorMessage(remoteOptionSelectFactory({
   getSuggestionsPromise: getChannelSelectOptionsSSA,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndIdAsValueAndNameAsLabel,
})));
